/**
 * Filen inneholder konstanter fra visningsdefinisjon for skattemeldingen som benyttes i SME og evt. andre applikasjoner
 * */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TEMA: function() {
        return TEMA;
    },
    KORTGRUPPER: function() {
        return KORTGRUPPER;
    },
    default: function() {
        return _default;
    }
});
var TEMA = {
    NAERING_ID: "naering"
};
var KORTGRUPPER = {
    NAERINGSINNTEKT_MV_ID: "naering.naeringsinntektMv.kortgruppe"
};
var _default = {
    TEMA: TEMA,
    KORTGRUPPER: KORTGRUPPER
};
